module.exports = __webpack_public_path__ + "media/images/countrysquared/bg-bf7b4a6d916df877d4e151826fda09a9.svg";